<template>
  <div class="payment-container tw-flex tw-flex-col tw-items-center tw-mt-8">
    <br />
    <br />
    <div class="tw-w-full tw-max-w-4xl tw-px-4">
      <!-- Header Section -->
      <div
          class="tw-w-full tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-4 tw-mb-4">
        <h2 style="color: #114cac" class="tw-text-2xl tw-font-semibold tw-mb-4">
          Choose your Mode of Payment
        </h2>
        <v-icon class="tw-text-blue-700">mdi-cash</v-icon>
      </div>

      <!-- TPO Payment Blocked / Gated Notice -->
      <div
          v-if="isTpoCover"
          class="pa-6 tw-rounded-lg tw-mb-8 tw-w-full tw-max-w-4xl tw-bg-yellow-100 tw-border tw-border-yellow-400 tw-text-center tpo-payment-gated-notice"
      >
        <v-icon color="warning" class="tw-mb-2" size="48">mdi-alert-circle</v-icon>
        <h3 class="tw-text-xl tw-font-bold tw-text-gray-800 tw-mb-2">Payment Not Available Online</h3>
        <p class="tw-text-base tw-text-gray-700 tw-mb-0">
          Important Notice: We no longer support the purchase of Third Party Only (TPO) motor insurance policies through our digital channels.
          For assistance with your insurance requirement, please contact our Customer Service team at
          <a href="mailto:customer.service@apollo.co.ke" class="tw-text-blue-600 tw-font-semibold hover:tw-underline">customer.service@apollo.co.ke</a>.
        </p>
      </div>

      <!-- Standard Payment Section for Supported Covers -->
      <div v-else class="tw-w-full tw-flex tw-flex-col tw-items-center payment-active-section">
        <!-- Premium Summary Section -->
        <div
            class="premium-summary tw-w-full tw-px-6 tw-py-4 tw-border tw-border-blue-200 tw-rounded-md tw-mb-6 tw-flex tw-items-center">
          <div class="tw-w-1/2 tw-text-left">
            <p style="color: #114cac" class="tw-font-bold tw-text-2xl">
              Premium Payable
            </p>
          </div>
          <div class="tw-border-l tw-border-gray-300 tw-h-8 tw-mx-4"></div>
          <div class="tw-w-1/2 tw-text-right">
            <p style="color: #114cac">Premium to pay:</p>
            <h2 class="tw-text-2xl tw-font-bold tw-text-black">
              Kshs. {{ premiumAmount }}
            </h2>
          </div>
        </div>

    <!-- Payment Options Section -->
    <div class="payment-options tw-flex tw-justify-center tw-gap-6 tw-mb-8 tw-w-full">
      <button
          class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
          :class="currentTab === 'M-Pesa' ? 'payment-btn-active' : 'payment-btn-inactive'"

          @click="setCurrentTab('M-Pesa')">
        <img :src="currentTab === 'M-Pesa'? '/icons/mpesa_express_white.svg': '/icons/mpesa_express_gray.svg'"  alt="">
      </button>
      <button
          class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
          :class="currentTab === 'Paybill' ? 'payment-btn-active' : 'payment-btn-inactive'"
          @click="setCurrentTab('Paybill')">
        <img :src="currentTab === 'Paybill'? '/icons/paybill_white.svg': '/icons/paybill_gray.svg'"  alt="">
      </button>
      <button v-if="isFlagEnabled('CUSTOMER_PORTAL_SHOW_CARD_PAYMENT_OPTION')"
          class="payment-btn tw-px-6 md:tw-px-10 tw-py-3 tw-rounded-xl tw-font-semibold tw-shadow"
          :class="currentTab === 'Card' ? 'payment-btn-active' : 'payment-btn-inactive'"
          @click="setCurrentTab('Card')">
        <img :src="currentTab === 'Card'? '/icons/card_white.svg': '/icons/card_gray.svg'" alt="">
      </button>

    </div>

    <!-- M-Pesa Payment Section -->
    <div
        v-if="currentTab === 'M-Pesa'"
        class="payment-form tw-w-full tw-px-6 tw-py-4">
      <p class="tw-text-left tw-text-blue-600 tw-font-medium">
        Please Enter Your Number or the number making payment
      </p>
      <v-form>
        <v-text-field
            v-model="phoneNumber"
            label="Enter Mobile Number"
            class="tw-w-full tw-mt-4"
            :rules="[required('Mobile Number'), validatePhoneNumber]"
            @input="handleMobileInput"></v-text-field>
      </v-form>
      <p class="tw-text-sm tw-text-blue-600 tw-mt-4">
        Note: The transaction name that will reflect in your statement is 'APA
        Insurance'
      </p>
      <p class="tw-text-sm tw-text-gray-600">
        For assistance:
        <span class="tw-text-blue-600">WhatsApp us at 0115 325 445</span>
      </p>
      <!-- Prompt Payment Button -->
      <div class="tw-text-center tw-mt-6">
        <button
            style="background-color: #114cac"
            class="tw-px-8 tw-py-3 tw-rounded-lg tw-text-white tw-font-bold tw-shadow"
            :disabled="loading || !phoneNumber"
            @click="handlePaymentFlow">
          <span v-if="!loading">Prompt Payment</span>
          <span v-else>Processing...</span>
        </button>
      </div>
    </div>

    <!-- Paybill Payment Section -->
    <div
        v-if="currentTab === 'Paybill'"
        class="payment-form tw-w-full tw-px-6 tw-py-4">
      <p class="tw-text-gray-600 tw-font-medium">From your phone:</p>
      <ul class="tw-list-disc tw-ml-6 tw-mt-4 tw-text-gray-700 tw-font-medium">
        <li>Go to Safaricom Menu</li>
        <li>Select M-PESA</li>
        <li>Select Lipa na M-PESA</li>
        <li>Select Paybill</li>
        <li>Enter Business No: <strong>511600</strong></li>
        <li>Enter Account No:{{ VehicleNo }}</li>
        <li>Enter Amount :{{ premiumAmount }}</li>
      </ul>
      <p class="tw-text-blue-600 tw-font-medium tw-mt-6">
        Enter the Mpesa transaction code you have received from MPESA:
      </p>
      <v-form>
        <v-text-field
            v-model="mpesaCode"
            label="Transaction Code"
            placeholder="E.g., XGB15280CV"
            class="tw-w-full tw-mt-4"
            :rules="[required('Transaction Code')]"></v-text-field>
      </v-form>
      <p class="tw-text-sm tw-text-blue-600 tw-mt-4">
        Note: The transaction name that will reflect in your statement is 'APA
        Insurance'
      </p>
      <p class="tw-text-sm tw-text-gray-600">
        For assistance:
        <span class="tw-text-blue-700">WhatsApp us at 0115 325 445</span>
      </p>
    </div>

    <!-- Card Payment Section -->
    <div
        v-if="currentTab === 'Card'"
        class="card-payment tw-w-full tw-px-6 tw-py-4"
        style="color: #114CAC;"
    >
      <div class="tw-flex tw-flex-wrap tw-gap-3 tw-items-center tw-justify-center tw-mb-6">
        <img src="/icons/cards.svg" alt="Credit cards" />
        <span class="tw-ml-3 tw-font-semibold tw-text-base">We accept Visa and Mastercard.</span>
      </div>
      <p class="tw-text-center  tw-font-medium tw-mb-6 tw-max-w-lg">
        Click the button below to be redirected to our secure payment gateway to enter your card details.
      </p>
      <div class="tw-text-center tw-mt-10">
        <button
            style="background-color: #114cac; min-width: 60%;"
            class="tw-px-12 tw-py-3 tw-text-white tw-font-bold tw-shadow"
            :disabled="loading"
            @click="handleCardPayment">
          <span v-if="!loading">Proceed with Card</span>
          <span v-else>Processing...</span>
        </button>
      </div>
    </div>

    <!-- Validate Mpesa Code Button -->
    <div v-if="currentTab === 'Paybill'" class="tw-text-center tw-mt-6">
      <button
          style="background-color: #114cac"
          class="tw-px-8 tw-py-3 tw-rounded-lg tw-text-white tw-font-bold tw-shadow"
          :disabled="!mpesaCode"
          @click="validateMpesaCode">
        Validate Mpesa Code
      </button>
    </div>
  </div>
</div>

    <!-- Success Modal -->
    <div
        v-if="showModal"
        class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50">
      <div
          class="tw-bg-white tw-rounded-lg tw-p-6 sm:tw-p-8 tw-shadow-lg tw-text-center tw-w-11/12 sm:tw-max-w-md tw-max-w-full">
        <!-- Icon Section -->
        <div class="tw-flex tw-justify-center">
          <v-icon size="24" color="#00A36C" class="tw-text-5xl"
          >mdi-check-circle</v-icon
          >
        </div>

        <!-- Title Section -->
        <h2
            class="tw-text-xl sm:tw-text-2xl tw-font-bold tw-mt-4 tw-text-black">
          Your payment has been successfully processed!
        </h2>

        <!-- Description Section -->
        <p class="tw-text-gray-700 tw-my-4 tw-text-sm sm:tw-text-base">
          Thank you for buying using the APA app. The certificate is sent
          automatically to the client's email (The email provided). In case you
          do not find the same, kindly check in the spam folders.
        </p>
        <p class="tw-text-gray-700 tw-my-4 tw-text-sm sm:tw-text-base">
          Hope you have a happy experience using the app. In case of any
          technical challenge, contact WhatsApp:
          <a
              href="https://wa.me/254115325445"
              class="tw-text-blue-600 hover:tw-underline"
          >0115 325 445</a
          >
        </p>
        <p class="tw-text-gray-700 tw-text-sm sm:tw-text-base">
          You are required to have your vehicle valued within 14 days from the
          date of payment, failure to which your cover will be downgraded to
          Third Party Only cover.
        </p>

        <!-- Button Section -->
        <button
            @click="redirectToHome"
            class="tw-bg-blue-600 tw-text-white tw-font-semibold tw-px-6 tw-py-3 tw-rounded-md tw-shadow-md tw-mt-6 hover:tw-bg-blue-700 tw-w-full sm:tw-w-auto">
          FINISH
        </button>
      </div>
    </div>

    <!-- Cancelled Modal -->
    <div
        v-if="showCancelledModal"
        class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50">
      <div
          class="tw-bg-white tw-rounded-lg tw-p-6 sm:tw-p-8 tw-shadow-lg tw-text-center tw-w-11/12 sm:tw-max-w-md tw-max-w-full">
        <!-- Icon Section -->
        <div class="tw-flex tw-justify-center">
          <v-icon size="24" color="#FF6B6B" class="tw-text-5xl"
          >mdi-close-circle</v-icon
          >
        </div>

        <!-- Title Section -->
        <h2
            class="tw-text-xl sm:tw-text-2xl tw-font-bold tw-mt-4 tw-text-black">
          Payment Cancelled
        </h2>

        <!-- Description Section -->
        <p class="tw-text-gray-700 tw-my-4 tw-text-sm sm:tw-text-base">
          Your payment was cancelled. You can try again or contact us for assistance.
        </p>
        <p class="tw-text-gray-700 tw-text-sm sm:tw-text-base">
          For assistance, contact WhatsApp:
          <a
              href="https://wa.me/254115325445"
              class="tw-text-blue-600 hover:tw-underline"
          >0115 325 445</a
          >
        </p>

        <!-- Button Section -->
        <button
            @click="showCancelledModal = false"
            class="tw-bg-blue-600 tw-text-white tw-font-semibold tw-px-6 tw-py-3 tw-rounded-md tw-shadow-md tw-mt-6 hover:tw-bg-blue-700 tw-w-full sm:tw-w-auto">
          TRY AGAIN
        </button>
      </div>
    </div>

    <!-- Pesapal Payment Modal -->
    <PesapaliFrame
        :show-modal="showPesapalModal"
        :amount="premiumAmount"
        :redirect-url="pesapalRedirectUrl"
        @close="closePesapalModal" />
  </div>
</template>

<script>
import axios from 'axios';
import { log } from '@/utils/errorLogger';
import PesapaliFrame from './PesapaliFrame';

const TPO_PAYMENT_BLOCKED_MSG = 'Payment for Third Party Only policies is not supported through digital channels.';
const TPO_GATE_FEATURE_FLAG = 'TPO_BUSINESS';

export default {
  name: 'MakePayment',
  components: {
    PesapaliFrame,
  },
  data() {
    return {
      showModal: false,
      showCancelledModal: false,
      showPesapalModal: false,
      currentTab: 'M-Pesa',
      phoneNumber: '',
      mpesaCode: '',
      premiumAmount: '',
      paymentInitiated: false,
      paymentStatus: null,
      stkLoading: false,
      timeoutId: null,
      loading: false,
      quoteDetails: {},
      VehicleNo: '',
      transactionDetails: null,
      stkDetails: null,
      pesapalRedirectUrl: '',
    };
  },
  computed: {
    isTpoCover() {
      if (this.isFlagEnabled(TPO_GATE_FEATURE_FLAG)) {
        return false;
      }
      if (!this.quoteDetails?.coverType) {
        return false;
      }
      return this.quoteDetails.coverType.toLowerCase().includes('third party');
    },
  },
  methods: {
    redirectToHome() {
      this.showModal = false;
      this.$router.push('/dashboard');
    },
    async fetchQuoteDetails() {
      const quoteId = localStorage.getItem('quoteId');
      if (!quoteId) {
        this.$toast.error('Quote ID not found. Please try again.');
        return;
      }
      try {
        const response = await axios.post('/motor/api/quote/portal/detail', {
          quoteId,
        });
        if (response.data && response.data.data) {
          this.quoteDetails = response.data.data;
          this.VehicleNo = this.quoteDetails.vehicle.regNo;

          // Determine the premium amount based on the cover type
          if (
            this.quoteDetails.coverType === 'Bima Bamba'
              && this.quoteDetails.premiumInstalments
          ) {
            this.premiumAmount = this.quoteDetails.premiumInstalments[0].premium;
          } else if (this.quoteDetails.coverType === 'Third Party') {
            this.premiumAmount = this.quoteDetails.totalPremium;
          } else if (this.quoteDetails.coverType === 'Comprehensive'
              && this.quoteDetails.premiumInstalments
          ) {
            this.premiumAmount = this.quoteDetails.premiumInstalments[0].premium;
          } else {
            this.premiumAmount = this.quoteDetails.totalPremium || 0;
          }
        } else {
          this.$toast.error('Failed to fetch quote details. Please try again.');
        }
      } catch (error) {
        log(error, this, 'fetchQuoteDetails');
        this.$toast.error('An error occurred while fetching quote details.');
      }
    },
    // Step 1: Create Transaction
    async createTransaction() {
      if (this.isTpoCover) {
        this.$toast.error(TPO_PAYMENT_BLOCKED_MSG);
        return;
      }
      const paymentModes = {
        'M-Pesa': 'MPESA_EXPRESS',
        Card: 'CARD',
        Paybill: 'MPESA_PAYBILL',
      };
      try {
        const payload = {
          agentId: '',
          quoteId: this.quoteDetails.quoteId,
          renewal: false,
          paymentMode: paymentModes[this.currentTab],
          type: 'quotation',
          vehicleReg: this.quoteDetails.vehicle.regNo,
          amount: this.premiumAmount,
          customerId: this.quoteDetails.customer.customerId,
        };

        const response = await axios.post(
          `/motor/api/payment/transaction/create?cacheBust=${new Date().getTime()}`,
          payload,
        );

        if (response.data && response.data.code === 0) {
          this.transactionDetails = response.data.data;
          this.$toast.success('Transaction created successfully.');
        } else {
          throw new Error(
            response.data.message || 'Failed to create transaction.',
          );
        }
      } catch (error) {
        log(error, this, 'createTransaction');
        this.$toast.error(error.message || 'Error creating transaction.');
        throw error;
      }
    },

    // Step 2: Initiate STK Push
    async initiateSTKPush() {
      try {
        if (!this.transactionDetails) {
          throw new Error(
            'Transaction details are missing. Please create a transaction first.',
          );
        }

        const payload = {
          accountReference: this.transactionDetails.orderId,
          customerPhoneNumber: this.phoneNumber,
          description: 'Happiness App',
          kraPin: '',
          payableAmount: this.premiumAmount,
          serviceType: 'MOTOR',
          transactionType: 'PAYMENT',
        };

        const response = await axios.post(
          `/motor/api/payment/transaction/stk?cacheBust=${new Date().getTime()}`,
          payload,
        );

        if (response.data && response.data.code === 0) {
          this.stkDetails = response.data.data;
          this.$toast.success(
            'STK Push initiated successfully. Check your phone to proceed.',
          );
        } else {
          throw new Error(
            response.data.message || 'Failed to initiate STK Push.',
          );
        }
      } catch (error) {
        log(error, this, 'initiateSTKPush');
        this.$toast.error(error.message || 'Error initiating STK Push.');
        throw error;
      }
    },
    async pollPaymentStatus(maxRetries = 6, interval = 10000) {
      let retries = 0;

      while (retries < maxRetries) {
        try {
          const payload = {
            customerId: this.transactionDetails.customerId,
            externalReference: '',
            message: this.stkDetails.responseDescription,
            mpesaAccountReference: this.transactionDetails.vehicleReg,
            mpesaRefOrCheckoutId: this.stkDetails.checkoutRequestId,
            orderId: this.transactionDetails.orderId,
            paymentMethod: 'M-Pesa',
            paymentResponse: this.stkDetails.responseDescription,
            success: true,
            transactionRef: this.transactionDetails.transactionRef,
          };

          // eslint-disable-next-line no-await-in-loop
          const response = await axios.post(
            `/motor/api/payment/transaction/validation?cacheBust=${new Date().getTime()}`,
            payload,
          );

          if (response.data && response.data.code === 0) {
            const { success, message } = response.data.data;

            if (success) {
              this.paymentStatus = 'SUCCESSFUL';
              localStorage.removeItem('selectedBranch');
              localStorage.removeItem('savedPolicyTypes');
              localStorage.removeItem('valuationDetails');
              localStorage.removeItem('vehicleDetails');
              localStorage.removeItem('policyDetails');
              localStorage.removeItem('personalData');
              localStorage.removeItem('rfq_journey_progress');
              this.showModal = true;
              return;
              // eslint-disable-next-line sonarjs/no-same-line-conditional
            }
            if (message.includes('FAILED')) {
              this.paymentStatus = 'FAILED';
              this.$toast.error('Payment failed. Please try again.');
              return; // Exit polling if failed
            }
          }
        } catch (error) {
          log(error, this, 'pollPaymentStatus');
          this.$toast.error('Error while validating payment status.');
        }

        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, interval));
        retries += 1;
      }

      this.paymentStatus = 'PENDING';
      this.$toast.error('Payment timed out. Please try again.');
    },
    // Full Flow Execution
    async handlePaymentFlow() {
      if (this.isTpoCover) {
        this.$toast.error(TPO_PAYMENT_BLOCKED_MSG);
        return;
      }
      this.loading = true;
      try {
        await this.createTransaction();
        await this.initiateSTKPush();
        await this.pollPaymentStatus();
      } catch (error) {
        log(error, this, 'handlePaymentFlow');
        this.$toast.error('Payment flow failed');
      } finally {
        this.loading = false;
      }
    },

    async pollPaybillStatus(maxRetries = 6, interval = 10000) {
      let retries = 0;

      while (retries < maxRetries) {
        try {
          const payload = {
            customerId: this.quoteDetails.customer.customerId,
            externalReference: '',
            mpesaAccountReference: this.VehicleNo,
            mpesaRefOrCheckoutId: this.mpesaCode,
            orderId: this.transactionDetails?.orderId,
            paymentMethod: 'Mobile',
            paymentResponse: 'being processed',
            message: 'Payment is being processed',
            success: true,
            transactionRef: this.transactionDetails?.transactionRef,
          };
          // eslint-disable-next-line no-await-in-loop
          const response = await axios.post(
            '/motor/api/payment/transaction/validation',
            payload,
          );

          if (response.data && response.data.code === 0) {
            const { success, message } = response.data.data;

            if (success) {
              this.paymentStatus = 'SUCCESSFUL';
              this.$toast.success('Paybill payment validated successfully!');
              localStorage.removeItem('selectedBranch');
              localStorage.removeItem('savedPolicyTypes');
              localStorage.removeItem('valuationDetails');
              localStorage.removeItem('vehicleDetails');
              localStorage.removeItem('policyDetails');
              localStorage.removeItem('personalData');
              localStorage.removeItem('rfq_journey_progress');
              this.showModal = true;
              return;
            }

            if (message.includes('FAILED')) {
              this.paymentStatus = 'FAILED';
              this.$toast.error('Paybill payment failed. Please try again.');
              return;
            }
          }
        } catch (error) {
          log(error, this, 'pollPaybillStatus');
          this.$toast.error('Error during Paybill validation.');
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, interval));
        retries += 1;
      }

      this.paymentStatus = 'PENDING';
      this.$toast.error('Paybill validation timed out. Please try again.');
    },

    async validateMpesaCode() {
      if (this.isTpoCover) {
        this.$toast.error(TPO_PAYMENT_BLOCKED_MSG);
        return;
      }
      if (!this.mpesaCode) {
        this.$toast.error('Please enter the Mpesa Transaction Code.');
        return;
      }
      this.loading = true;

      try {
        if (!this.transactionDetails || !this.transactionDetails.orderId) {
          await this.createTransaction();
        }

        await this.pollPaybillStatus();
      } catch (error) {
        log(error, this, 'validateMpesaCode');
        this.$toast.error('Paybill validation failed.');
      } finally {
        this.loading = false;
      }
    },

    handleMobileInput(value) {
      const cleanNumber = value.replace(/\D/g, '');

      if (cleanNumber.startsWith('0')) {
        this.phoneNumber = `254${cleanNumber.slice(1)}`;
      } else {
        this.phoneNumber = cleanNumber.startsWith('254')
          ? cleanNumber
          : `254${cleanNumber}`;
      }
    },
    validatePhoneNumber(value) {
      return value && value.startsWith('254') && value.length === 12
        ? true
        : 'Enter a valid 9-digit phone number';
    },
    setCurrentTab(tab) {
      this.currentTab = tab;
    },
    required(field) {
      return (value) => !!value || `${field} is required`;
    },
    async initiateCardPayment() {
      try {
        if (!this.transactionDetails || !this.transactionDetails.orderId) {
          throw new Error('Order ID is missing.');
        }

        // Construct callback URLs properly
        const currentUrl = globalThis.location.href; // eslint-disable-line no-undef
        const separator = currentUrl.includes('?') ? '&' : '?';

        const payload = {
          orderId: this.transactionDetails.orderId,
          amount: this.premiumAmount,
          callbackUrl: `${currentUrl}${separator}status=success`,
          cancellationUrl: `${currentUrl}${separator}status=cancelled`,
        };

        const response = await axios.post(
          '/motor/api/payment/card/initiate',
          payload,
        );

        if (response.data && response.data.success && response.data.data) {
          const { redirectUrl } = response.data.data;
          if (!redirectUrl) {
            throw new Error('Redirect URL not received from payment gateway.');
          }
          this.pesapalRedirectUrl = redirectUrl;
        } else {
          throw new Error(response.data.msg || 'Failed to initiate card payment.');
        }
      } catch (error) {
        log(error, this, 'initiateCardPayment');
        this.$toast.error(error.message || 'Error initiating card payment.');
        throw error;
      }
    },
    async handleCardPayment() {
      if (this.isTpoCover) {
        this.$toast.error(TPO_PAYMENT_BLOCKED_MSG);
        return;
      }
      this.loading = true;
      try {
        await this.createTransaction();
        await this.initiateCardPayment();
        this.showPesapalModal = true;
      } catch (error) {
        log(error, this, 'handleCardPayment');
        this.$toast.error('Failed to initiate card payment.');
      } finally {
        this.loading = false;
      }
    },
    closePesapalModal() {
      this.showPesapalModal = false;
    },
    async validateCardPayment(orderTrackingId, maxRetries = 30) {
      this.loading = true;
      let retries = 0;

      while (retries < maxRetries) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const response = await axios.get(
            `/motor/api/payment/card/validate/${orderTrackingId}`,
          );

          if (response.data?.data?.paymentStatusDescription) {
            const status = response.data.data.paymentStatusDescription.toLowerCase();

            if (status === 'completed') {
              this.loading = false;
              this.showModal = true;
              this.cleanupUrlParams();
              localStorage.removeItem('selectedBranch');
              localStorage.removeItem('savedPolicyTypes');
              localStorage.removeItem('valuationDetails');
              localStorage.removeItem('vehicleDetails');
              localStorage.removeItem('policyDetails');
              localStorage.removeItem('personalData');
              localStorage.removeItem('rfq_journey_progress');
              return;
            }

            if (status === 'failed') {
              this.loading = false;
              this.showCancelledModal = true;
              this.cleanupUrlParams();
              this.$toast.error('Payment failed. Please try again.');
              return;
            }
          }
        } catch (error) {
          log(error, this, 'validateCardPayment');
        }

        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, 10000));
        retries += 1;
      }

      this.loading = false;
      this.showCancelledModal = true;
      this.cleanupUrlParams();
      this.$toast.error('Payment validation timed out. Please contact support.');
    },
    cleanupUrlParams() {
      const query = { ...this.$route.query };
      delete query.status;
      delete query.OrderTrackingId;
      delete query.OrderMerchantReference;
      this.$router.replace({ query });
    },
  },
  async mounted() {
    await this.fetchQuoteDetails();

    // Check for payment callback status from URL
    const { status, OrderTrackingId } = this.$route.query;

    if (status === 'success' && OrderTrackingId) {
      await this.validateCardPayment(OrderTrackingId);
    } else if (status === 'cancelled') {
      this.showCancelledModal = true;
      this.cleanupUrlParams();
    }
  },
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
};
</script>

<style scoped>
.payment-container {
  max-width: 600px;
  margin: auto;
}

.payment-btn {
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.payment-btn-inactive {
  background-color: #F4F6F8;
  color: #374151;
}

.payment-btn-inactive:hover {
  background-color: #d6dae1;
  border-color: #2563eb;
}

.payment-btn-active {
  background-color: #114CAC;
  color: white;
  border-color: #114CAC;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4);
  transform: scale(1.02);
}

.card-icon {
  height: 32px;
  width: auto;
  background: #E0E0E0;
  padding: 4px 8px;
  border-radius: 4px;
}
</style>
